
<template>
  <div class="page-wrapper rep-dashboard-wrapper">
    <div class="container-fluid">
      <div class="row">
        <div class="col-xxl-3 col-xl-4 col-lg-6 col-md-6 mb-4" >
          <div class="overallInfo-blockWrapper benefitstore-dash">
            <div class="benefitstore-image">
              <img src="../../assets/images/dashbenefit-store.svg" alt="" />
            </div>
            <div class="benefitstore-content">
              <h2>The Benefit Store</h2>
              <button
                @click="redirectToBenefitStore()"
                class="dashboard-button mb-1"
              >
                Add or Enroll
              </button>
              <button class="dashboard-button mt-2"  @click="openModal('viewPlanModal')" v-if="!hideViewPlanBtn">View Plans</button>
            </div>
          </div>
        </div>
        <div class="col-xxl-3 col-xl-4 col-lg-6 col-md-6 mb-4">
          <h5 class="title-section">Manage Business</h5>
          <div class="overallInfo-blockWrapper rep-dash p-3"
         >
            <div class="manage-btn ">
              <button  @click="routeToLink('/view-quotes')"><img :src="pqs" alt="">Personalized Quoting System (PQS)</button>
              <button  @click="routeToLink('/view-members')">Members</button>
              <button @click="routeToLink('/view-employers')" >Employer and Groups</button>
              <button v-if="isDownlineHasAccess"  @click="routeToLink('/view-downline-reps')" class="mb-0">Downline Reps </button>
            </div>
          </div>
        </div>
       
        <div class="col-xxl-3 col-xl-4 col-lg-6 col-md-6 mb-4" >
          <h5 class="title-section">Apps</h5>
          <div class="overallInfo-blockWrapper rep-dash p-3">
            <div class="manage-btn apps-btn">
              <!-- <button  @click="redirectToBenefitStore()" >
                <img :src="benefit" alt="benefit store logo" />Benefit Store
              </button>
              <button @click="openPlanConfigurator($endpoint.PLAN_CONFIGURATOR_URL)">
                Plan Configurator
              </button> -->
              <button  v-if="hasAccessToCrmAcm" @click="openLinkInNewTab($endpoint.CRM_URL)">
                <img :src="crm" alt="" />CRM
              </button>
              <button @click="openLinkInNewTab(calendarLink)">
                <img :src="calendar" alt="" />
                Calendar
              </button>
              <button @click="routeToLink('/nuera-blogs')" class="mb-0">
                <img :src="neurablog" alt="" />NuEra Blogs
              </button>
            </div>
          </div>
        </div>
        <div class="col-xxl-3 col-xl-4 col-lg-6 col-md-6 mb-4" v-if="uplineInfo.sso_user_id != 35311">
         <template >
          <h5  class="title-section">
            Commission
          </h5>

          <div class="overallInfo-blockWrapper rep-dash p-3" v-if="!isDataLoaded">
            <no-content :text="messageText" />
          </div>
          <div class="overallInfo-blockWrapper rep-dash p-3" v-else>

             <p class="mb-2">Current Month : <b>{{currentMonth}}</b>

            </p>
             <p class="mb-2">Current Commission Amount: <b id="commission_current_month">${{currentMonthCommission}}</b>
              <eye-button
													id="commission_current_month"
                          :nonInput="1"
                          :value="'$'+currentMonthCommission"
                          initialValue="XXXX.XX"
													class="toggle-eye-icon"
													type="text"
												></eye-button>
            </p>
             <p class="mb-2">Year to Date Commission Amount: <b id="commission_year_to_date">${{totalCommission}}</b>
                          <eye-button
													id="commission_year_to_date"
                          :nonInput="1"
                          :value="'$'+totalCommission"
                          initialValue="XXXX.XX"
													class="toggle-eye-icon"
													type="text"
												></eye-button>
                      </p>
            <div class="comm-btn-wrap">
              <button class="btn-dash comm-btn mb-0 mb-2" @click="routeToLink('/commissions')">Commission Statements </button>
              <template v-if="uplineInfo.sso_user_id != 35311">
                <button class="btn-dash comm-btn mb-0 mb-2" @click="routeToLink('/commission-config')">Commission Schedule </button>
              </template>
              <button class="btn-dash comm-btn mb-0 " @click="routeToLink('/invoice-insights')">Member Invoice Insights</button>
            </div>
          </div>
         </template>

          <!-- <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6">
          <benefit-store />
        </div> -->
          <!-- <div class="col-xxl-3 col-xl-3 col-lg-3 mb-4">
          <rep-info />

        </div> -->
        </div>
      </div>

      <div class="row">
        <div
          class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 vue-custom-scrollbar"
        >
          <pending-items />
        </div>
      </div>
    
      <div class="row">
        <dash-messages />
        <dash-notification />
        <dash-knowledge />
        <resources />
        <!-- <business-overview /> -->
      </div>
      <div>
        <view-plan-modal :platformInfo.sync="platformInfo"  :repInfo="repInfo"/>
      </div>
      <!-- <overall-info /> -->
      <!-- <commission-projected /> -->
      <!-- <div class="row">
        <dash-messages />

      </div> -->
      <!-- <div class="row">
        <resources />
      </div> -->
      <!-- <RepInfo v-if="showValidationPopUp"/> -->
    </div>
  </div>
</template>

<script>
import Helper from "@/resource/Helper";
// import RepInfo from "@/components/AccountInfo/RepInfo.vue"
import Resources from "@/views/Dashboard/partials/Resources.vue";
import PendingItems from "@/views/Dashboard/partials/PendingItems.vue";
import DashMessages from "@/views/Dashboard/partials/DashMessages.vue";
// import BenefitStore from "@/views/Dashboard/partials/BenefitStore.vue";
import DashKnowledge from "@/views/Dashboard/partials/DashKnowledge.vue";
// import BusinessOverview from "@/views/Dashboard/partials/BusinessOverview.vue";
// import PersonalizedSites from "@/views/Dashboard/partials/PersonalizedSites.vue";
import DashNotification from "@/views/Dashboard/partials/DashNotification.vue";
// import repInfo from '@/components/dashboard/repInfo.vue'
import Api from "@/resource/Api";
import ViewPlanModal from "./model/ViewPlansModal.vue";
import endpoint from "@/resource/EndPoints/endpoints"
// import {restrictedReps} from "@/utils/constant";

// our apps logos
import pqsImage from "../../assets/images/pqs.svg";
import benefitlogo from "../../assets/images/benefit-store-white.svg";
import neurablogImage from '../../assets/images/blog.svg';
import crmImage from '../../assets/images/crm.png';
import acmImage from '../../assets/images/acm-side.svg';
import calendarImage from '../../assets/images/calendar.svg';

export default {
  name: "NeuraDashboard",
  components: {
    DashMessages,
    DashKnowledge,
    PendingItems,
    Resources,
    DashNotification,
    ViewPlanModal,
  },
  data: () => ({
    currentMonth: '',
    currentMonthCommission: '',
    totalCommission: '',
    messageText: '',
    isDataLoaded: false,
    platformInfo: [],
    hideViewPlanBtn: false,
    pqs: pqsImage,  
    benefit:benefitlogo,
    neurablog: neurablogImage,
    crm: crmImage,
    acm: acmImage,
    calendar: calendarImage,
    isDownlineHasAccess:false,
  }),
  created() {
    Helper.dashboardGetters();
    this.$store.dispatch("getRepInfo");
    this.getCommissionInfo();
    this.getRistrictDownlineFlag()
  },
  computed: {
    showValidationPopUp() {
      return !this.$store.getters.rep.is_data_confirmed;
    },
    repInfo () {
      return this.$store.getters.rep
    },
    hideViewPlanBtn () {
      return this.$store.getters.isViewPlatformList
    },
    uplineInfo(){
      return this.$store.getters.upLineInfo
    },
    repCode() {
      return this.$store.getters.repId;
    },
   
    repEmail(){
      return this.$store.getters.repEmail;
    },
    accessToken(){
     return this.$store.getters.accessToken
    },
    calendarLink() {
      return Helper.calendarAppLink();
    },
    hasAccessToCrmAcm() {
      const repInfo = this.repInfo;
      if (!repInfo) return false;
      
      // Check if both agent_level and agent_level_2 are greater than or equal to 3
      return (repInfo.agent_level >= 3 || repInfo.agent_level_2 >= 3);
    }
  },

   
  methods: {
    redirectToBenefitStore() {
      let benefitStoreLink;
      benefitStoreLink = Helper.benefitStoreLink();
      window.open(benefitStoreLink, "_blank");
    },
    openModal (modalId) {
      if (this.repInfo.platformList.is_multiple) {
        this.platformInfo = this.repInfo.platformList.data;
        this.$bvModal.show(modalId);
       } else {
        let platformInfo = this.repInfo.platformList.data[0]
        let agentIdEncrypted = btoa(this.repInfo.id)
        let benefitStoreLink = `${endpoint.BENEFIT_STORE_URL}/view-plans/${agentIdEncrypted}/${platformInfo.group_id}/${platformInfo.group_id}`
        window.open(benefitStoreLink, '_blank');
        }
    },
    openPlanConfigurator(url){
      const configurator_url = new URL(url);
      configurator_url.searchParams.append("email", this.repEmail);
      configurator_url.searchParams.append("token", btoa(this.accessToken))
      window.open(configurator_url, "_blank");
    },
    openLinkInNewTab(url) {
       window.open(url, '_blank'); 
    },
    getCommissionInfo() {
      let url;
      let app = this
      app.isDataLoaded = false
      this.messageText = "Loading commission...";
      url = `v2/commission/overview`;
      Api.get(url)
          .then((res) => {
            app.isDataLoaded = true
            let result = res.data.data
            app.currentMonth = result.current_month
            app.currentMonthCommission = result.current_month_commission
            app.totalCommission = result.total_commission
          })
          .catch((err) => {
            app.isDataLoaded = true
            console.log(err)
          });
    },
    getRistrictDownlineFlag() {
      let path = "v2/rep-restriction-downline";
      this.isLoading = true;
      Api.post(path)
          .then((res) => {
            this.isDownlineHasAccess=res.data.has_access
                
          })
          .catch((err) => {            
            console.error("Error: ", err.response.data.message);
          })
          .finally(() => {
            this.isLoading = false;
          });
    },
    routeToLink (url) {
      let app = this
      app.$router.push(`${url}`)
    },
  },
  mounted(){
this.$store.dispatch('checkIsL713Rep')
this.$store.dispatch('isPlanSwitchActiveForRep');
  }
};
</script>
<style src="@/assets/css/repdashboard.css"></style>
<style scoped>
.toggle-eye-icon {
  /* float:right; */
   margin-left: 2% !important;
}

.manage-btn button img{
  max-height: 1.25rem ;
  padding-right: 0.35rem;
  vertical-align: middle
}

.apps-btn button{

  background: transparent linear-gradient(103deg,#8360c3,#2ebf91) 0 0 no-repeat padding-box;
}
</style>